module.exports = __webpack_public_path__ + "static/vehicle-onboard-item-431cda4d5bb735a44d93e9417496908b.png";